import Swiper from 'swiper/js/swiper.min';
export default {
  init: function init() {
    $('.thumb-swiper').each(function (i, el) {
      var swiper_thumbs = new Swiper(el, {
        spaceBetween: 16,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });
      $($('.gallery-swiper').get(i)).data('thumbs', swiper_thumbs);
    });
    $('.gallery-swiper').each(function (i, el) {
      console.log('el: ', el);
      new Swiper(el, {
        autoHeight: false,
        speed: 200,
        effect: 'fade',
        centeredSlides: true,
        fadeEffect: {
          crossFade: true
        },
        thumbs: {
          swiper: $(el).data('thumbs')
        }
      });
    });
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/exhibition-detail.js